import { RENDERER_TYPES } from "../../../../enums";

const CLIENT_CAMPAIGNS_COLUMNS = [
  {
    title: "Date",
    field: "date",
    dataType: "string",
    rendererType: RENDERER_TYPES.FULL_DATE_FROM,
    width: "25%",
  },
  {
    title: "Label",
    field: "label",
    dataType: "string",
    width: "25%",
  },
  {
    title: "Budget",
    field: "budget",
    dataType: "string",
    rendererType: RENDERER_TYPES.AMOUNT,
    width: "20%",
  },
  {
    title: "Meetings",
    field: "meetings",
    dataType: "string",
    rendererType: RENDERER_TYPES.NUMBER,
    width: "20%",
  },
  {
    title: "Action",
    rendererType: RENDERER_TYPES.ACTION,
    width: "10%",
  },
];

export { CLIENT_CAMPAIGNS_COLUMNS };
